<template>
    <v-flex class="accomplishments" v-if="Object.values(this.accomplishments).length > 0 || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.ACCOMPLISHMENTS}}<i v-if="isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id="accomplishments_edit" @click="isAccomplishmentDialog = true"> </i></v-flex>
        <v-flex v-if="!isSectionVisible && isCurrentUser">{{memberProfileConstants.DEFAULT_EDIT_TEXT.ACCOMPLISHMENTS}}</v-flex>
        <status-overlay :action="loadGetAccomplishmentsAction" content-height="200px">
        </status-overlay>
        <v-flex v-if="this.accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS]" class="accomplishments__row">
            <v-flex tag="strong">{{memberProfileConstants.ACCOMPLISHMENT.EXTRN_HONORS_AWARDS}}</v-flex>
            <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS]" :key="index">
                <v-flex tag="span" v-if="accomplishment.url"><a class="accomplishments__urlLinkIsNotNull"  :href="normalizeUrl(accomplishment.url)" target="_blank" :data-qe-id="`member-accomplishment_${index}`">{{accomplishment.name}}</a></v-flex>
                <v-flex tag="span" v-if="!accomplishment.url"><span class="accomplishments__urlLinkIsNull">{{accomplishment.name}}</span></v-flex>
                <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="this.accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS]" class="accomplishments__row">
            <v-flex tag="strong">{{memberProfileConstants.ACCOMPLISHMENT.PUBLICATIONS}}</v-flex>
            <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS]" :key="index">
                <v-flex tag="span" v-if="accomplishment.url"><a class="accomplishments__urlLinkIsNotNull"  :href="normalizeUrl(accomplishment.url)" target="_blank" :data-qe-id="`member-accomplishment_${index}`">{{accomplishment.name}}</a></v-flex>
                <v-flex tag="span" v-if="!accomplishment.url"><span class="accomplishments__urlLinkIsNull">{{accomplishment.name}}</span></v-flex>
                <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="this.accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS]" class="accomplishments__row">
            <v-flex tag="strong">{{memberProfileConstants.ACCOMPLISHMENT.SPEAKING_EVENTS}}</v-flex>
            <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS]" :key="index">
                <v-flex tag="span" v-if="accomplishment.url"><a class="accomplishments__urlLinkIsNotNull"  :href="normalizeUrl(accomplishment.url)" :data-qe-id="`member-accomplishment_${index}`" target="_blank">{{accomplishment.name}}</a></v-flex>
                <v-flex tag="span" v-if="!accomplishment.url"><span class="accomplishments__urlLinkIsNull">{{accomplishment.name}}</span></v-flex>
                <v-flex tag="small">{{speakingEventDate(accomplishment.startDate)}}</v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="this.accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS]" class="accomplishments__row">
            <v-flex tag="strong">{{memberProfileConstants.ACCOMPLISHMENT.VIDEOS}}</v-flex>
            <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS]" :key="index">
                <v-flex tag="span" v-if="accomplishment.url"><a class="accomplishments__urlLinkIsNotNull"  :href="normalizeUrl(accomplishment.url)" :data-qe-id="`member-accomplishment_${index}`" target="_blank">{{accomplishment.name}}</a></v-flex>
                <v-flex tag="span" v-if="!accomplishment.url"><span class="accomplishments__urlLinkIsNull">{{accomplishment.name}}</span></v-flex>
                <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="this.accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS]" class="accomplishments__row">
            <v-flex tag="strong">{{memberProfileConstants.ACCOMPLISHMENT.PATENTS}}</v-flex>
            <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS]" :key="index">
                <v-flex tag="span" v-if="accomplishment.url"><a class="accomplishments__urlLinkIsNotNull"  :href="normalizeUrl(accomplishment.url)" :data-qe-id="`member-accomplishment_${index}`" target="_blank">{{accomplishment.name}}</a></v-flex>
                <v-flex tag="span" v-if="!accomplishment.url"><span class="accomplishments__urlLinkIsNull">{{accomplishment.name}}</span></v-flex>
                <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
            </v-flex>
        </v-flex>
        <v-dialog scrollable v-model="isAccomplishmentDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.ACCOMPLISHMENT.EDIT_ACCOMPLISHMENT}}
                    <i class="fas fa-times" data-qe-id ="accomplishments_editDialog" @click="isAccomplishmentDialog = false"></i>
                </v-card-title>
                <v-card-text ref="accomplishmentScroll" class="inner-scrollbar">
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ACCOMPLISHMENT.EXTRN_HONORS_AWARDS}}
                            <span class="add-edit-btn" data-qe-id ="editAccomplishments_awards" @click="openAccomplishment(memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS]" :key="index">
                            <v-flex tag="strong">{{accomplishment.name}} <i class="fas fa-pencil-alt" :data-qe-id="'editAccomplishments_awardsName_' + index" @click="editAccomplishment(accomplishment)"></i></v-flex>
                            <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ACCOMPLISHMENT.PUBLICATIONS}}
                            <span class="add-edit-btn" data-qe-id ="editAccomplishments_publications" @click="openAccomplishment(memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS]" :key="index">
                            <v-flex tag="strong">{{accomplishment.name}} <i class="fas fa-pencil-alt" :data-qe-id ="'editAccomplishments_publicationsName_' +index" @click="editAccomplishment(accomplishment)"></i></v-flex>
                            <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ACCOMPLISHMENT.SPEAKING_EVENTS}}
                            <span class="add-edit-btn" data-qe-id ="editAccomplishments_speakingEvents" @click="openAccomplishment(memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS]" :key="index">
                            <v-flex tag="strong">{{accomplishment.name}} <i class="fas fa-pencil-alt" :data-qe-id ="'editAccomplishments_speakingEventsName_' +index" @click="editAccomplishment(accomplishment)"></i></v-flex>
                            <v-flex tag="small">{{speakingEventDate(accomplishment.startDate)}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ACCOMPLISHMENT.VIDEOS}}
                            <span class="add-edit-btn" data-qe-id ="editAccomplishments_videos" @click="openAccomplishment(memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS]" :key="index">
                            <v-flex tag="strong">{{accomplishment.name}} <i class="fas fa-pencil-alt" :data-qe-id ="'editAccomplishments_videosName_' +index" @click="editAccomplishment(accomplishment)"></i></v-flex>
                            <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.ACCOMPLISHMENT.PATENTS}}
                            <span class="add-edit-btn" data-qe-id ="editAccomplishments_patents" @click="openAccomplishment(memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="accomplishments__dataRow" v-for="(accomplishment, index) in accomplishments[memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS]" :key="index">
                            <v-flex tag="strong">{{accomplishment.name}} <i class="fas fa-pencil-alt" :data-qe-id ="'editAccomplishments_patentsName_' +index" @click="editAccomplishment(accomplishment)"></i></v-flex>
                            <v-flex tag="small">{{accomplishment.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn flat class="primary_btn" data-qe-id ="editAccomplishments_closeBtn" @click="cancel()">
                            {{appCommonConstants.CLOSE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="accomplishmentDialog" content-class="medium">
            <AccomplishmentsDialog v-if="accomplishmentDialog"
                data-qe-id ="editAccomplishments_scroll"
                @click="handleDialog"
                :arrAccomplishments="arrAccomplishments"
                :modelAccomplishment="modelAccomplishment"
                :isEditAccomplishment="isEditAccomplishment"
                :headerLabel="headerLabel" 
                :memberId="memberId" />
        </v-dialog>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { appCommonConstants } from "../appCommon.constants.js";
    import AccomplishmentsDialog from "./EditDialogues/AccomplishmentsDialog";
    import Vue from 'vue';
    import { normalizeUrl } from '@/common/utils/utils';
    import moment from 'moment';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';

    export default {
        name: "Accomplishments",
        data: () => ({
            normalizeUrl,
            memberProfileConstants,
            accomplishmentDialog: false,
            isAccomplishmentDialog: false,
            isEditAccomplishment: false,
            appCommonConstants,
            headerLabel: '',
            arrAccomplishments: [],
            modelAccomplishment: {
                id: null,
                name: null,
                type: null,
                endDate: null,
                startDate: '',
                url: null,
                location: null,
                topic: null,
                description: null,
                industryCategory: null,
                subIndustryCategory: null,
                isEdit: false,
                isDelete: true,
                isAdd: false,
                isSuccess: false,
                isEditDialog: false,
                startMonth: '',
                startYear: '',
                isSave: true,
                datePickerMenu: false,
                isSearch: false,
            },
        }),
        components: {
            AccomplishmentsDialog,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getAccomplishments(this.memberId);
        },
        methods: {
            ...mapActions({
                getAccomplishments: `memberProfile/${storeAction.getAccomplishments}`,
            }),
            speakingEventDate(publishedDate) {
                return publishedDate ? moment(publishedDate, 'YYYY-MM-DD').format('MMMM YYYY') : '';
            }, 
            scrollTop() {
                if (this.$refs.accomplishmentScroll) {
                    this.$refs.accomplishmentScroll.scrollTop = 0;
                }
            }, 
            headerTextForModelDialog(categoryType) {
                let headerText = '';
                if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS) {
                    headerText = this.memberProfileConstants.ACCOMPLISHMENT.EXTRN_HONORS_AWARDS;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS) {
                    headerText = this.memberProfileConstants.ACCOMPLISHMENT.PUBLICATIONS;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS) {
                    headerText = this.memberProfileConstants.ACCOMPLISHMENT.SPEAKING_EVENTS;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS) {
                    headerText = this.memberProfileConstants.ACCOMPLISHMENT.PATENTS;
                } else if (categoryType === this.memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS) {
                    headerText = this.memberProfileConstants.ACCOMPLISHMENT.VIDEOS;
                }
                return headerText;
            },       
            openAccomplishment(categoryType) {
                this.modelAccomplishment.isSave = true;
                this.headerLabel = this.headerTextForModelDialog(categoryType);
                this.isEditAccomplishment = false;
                this.accomplishmentDialog = true;
                this.arrAccomplishments = [];
                this.modelAccomplishment.type = categoryType;     
                this.modelAccomplishment.subIndustry = [];
                this.arrAccomplishments.push(Vue.util.extend({}, this.modelAccomplishment));
                this.scrollTop();
            },
            editAccomplishment(accomplishment) {
                this.arrAccomplishments = [{
                    id: accomplishment.id,
                    name: accomplishment.name,
                    type: accomplishment.type,
                    endDate: accomplishment.endDate,
                    startDate: accomplishment.startDate,
                    url: accomplishment.url,
                    location: accomplishment.location,
                    topic: accomplishment.topic,
                    description: accomplishment.description,
                    industryCategory: accomplishment.industryCategory,
                    subIndustryCategory: accomplishment.subIndustryCategory,
                    isEditDialog: true,
                    startMonth: accomplishment.startDate ? accomplishment.startDate.split(' ')[0] : null,
                    startYear: accomplishment.startDate ? Number(accomplishment.startDate.split(' ')[1]) : null,
                    isSave: false,
                    subIndustry: this.industory[accomplishment.industryCategory],
                }];
                this.accomplishmentDialog = true;
                this.isEditAccomplishment = true;
                this.headerLabel = this.headerTextForModelDialog(accomplishment.type);
                this.scrollTop();
            },
            cancel() {               
                this.isAccomplishmentDialog = false;
                this.scrollTop();
            },
            handleDialog(variable) {
                this.accomplishmentDialog = variable;
            },
        },
        computed: {
            ...mapGetters({
                accomplishments: `memberProfile/${storeGetters.accomplishments}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            }),
            ...mapState("actionState", ["actions"]),
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            isSectionVisible() {
                return this.accomplishments !== "" &&
                    ((this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS] && this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_EXTRN_HONORS_AWARDS].length > 0) ||
                        (this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS] && this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_PUBLICATIONS].length > 0) ||
                        (this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS] && this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_SPEAKING_EVENTS].length > 0) ||
                        (this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS] && this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_VIDEOS].length > 0) ||
                        (this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS] && this.accomplishments[this.memberProfileConstants.ACCOMPLISHMENT.DATA_PATENTS].length > 0));
            },
            loadGetAccomplishmentsAction() {
                return this.actions[storeAction.getAccomplishments];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .accomplishments {
        border-bottom: 1px solid $ypo-open-blue-gray;
        margin-bottom: 20px;
        padding-bottom: 10px;
        padding: 0 20px 20px 20px;
        position: relative;

        &__row {
            margin-bottom: 15px;

            strong {
                display: block;
                margin-bottom: 5px;
            }

            span {
                display: block;
            }
        }

        &__dataRow {
            margin-bottom: 10px;
        }

        &__urlLinkIsNotNull {
            text-decoration: none;
            color: $black;
            font-size: 14px;
            cursor: pointer;
        }

        &__urlLinkIsNull {
            text-decoration: none;
            color: $black;
            font-size: 14px;
        }

        @media (max-width: 1199px){
            padding: 0 0 20px 0;
        } 

        .overlay {
            top: 35px;
        }
    }

    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;

        span {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            cursor: pointer;
        }

        i {
            color: $ypo-dark-background-gray;
            font-size: 14px;
            position: relative;
            left: 5px;
            margin-right: 40px;
            cursor: pointer;
        }

        em {
            color: $ypo-cta;
            font-family: "Noto Sans";
            font-size: 14px;
            line-height: 24px;
            font-style: normal;
            margin-left: 10px;
            cursor: pointer;
        }
    }
</style>
